// Receipt of a cached server channel snapshot is independent of device telemetry.
// Refresh every 15s; tolerate two missed refreshes before withholding live claims.
export const CHANNEL_STATUS_TTL_MS = 45000;

export function channelSnapshotFresh(liveState, now = Date.now()) {
  const received = Date.parse(liveState?.observedAt);
  return Number.isFinite(received) && received <= now + 2000 && now - received <= CHANNEL_STATUS_TTL_MS;
}
